import React from "react";

export const Rocket = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 603.296 603.296"
    height="25"
    width="25"
    viewBox="0 0 603.296 603.296"
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
  >
    <g>
      <g id="Page-1_5_">
        <g id="_x30_06---Starship">
          <path
            id="Shape_36_"
            d="m556.642 165.335-44.007 44.007 21.52 21.531c2.037 2.051 4.809 3.205 7.7 3.205s5.662-1.154 7.7-3.205l33.295-33.729c2.092-2.118 3.222-5.002 3.125-7.977l-1.975-59.471c-7.649 12.938-16.835 24.905-27.358 35.639z"
          />
          <path
            id="Shape_35_"
            d="m393.855 90.681 44.083-44.061c10.717-10.499 22.662-19.667 35.574-27.305l-59.58-1.888c-3.002-.097-5.909 1.054-8.031 3.18l-33.523 33.61c-2.041 2.047-3.181 4.825-3.167 7.716s1.181 5.657 3.243 7.684z"
          />
          <path
            id="Shape_34_"
            d="m172.389 382.655c-2.88.008-5.643-1.137-7.673-3.18l-14.488-14.477-58.495 58.495 14.531 14.477c2.821 2.725 3.953 6.76 2.959 10.554-.993 3.794-3.956 6.758-7.751 7.751-3.794.993-7.829-.138-10.554-2.959l-14.531-14.477-21.575 21.575 51.69 51.69 36.345 36.345 21.575-21.575-44.05-43.985c-4.113-4.258-4.054-11.027.132-15.213s10.955-4.245 15.213-.132l44.018 44.018 58.495-58.495-44.007-44.018c-4.113-4.258-4.054-11.027.132-15.213s10.955-4.245 15.213-.132l44.018 44.018 21.835-21.846 36.605-36.605-44.018-44.018c-2.821-2.725-3.953-6.76-2.959-10.554.993-3.794 3.956-6.758 7.751-7.751 3.794-.993 7.829.138 10.554 2.959l44.018 44.018 58.506-58.506-44.017-44.019c-4.258-4.258-4.258-11.163 0-15.421s11.163-4.258 15.421 0l44.018 44.018 58.495-58.495-44.018-44.018c-4.113-4.258-4.054-11.027.132-15.213s10.955-4.245 15.213-.132l44.018 44.018 14.477-14.477 44.007-44.007-88.014-88.046-58.506 58.495 14.477 14.477c2.934 2.696 4.154 6.783 3.179 10.647-.975 3.863-3.989 6.881-7.851 7.862s-7.951-.234-10.651-3.163l-14.477-14.477-58.495 58.495 14.477 14.477c2.821 2.725 3.953 6.76 2.959 10.554-.993 3.794-3.956 6.758-7.751 7.751-3.794.993-7.829-.138-10.554-2.959l-14.499-14.466-58.495 58.495 14.434 14.477c2.821 2.725 3.953 6.76 2.959 10.554-.993 3.794-3.956 6.758-7.751 7.751-3.794.993-7.829-.138-10.554-2.959l-14.477-14.477-58.506 58.495 14.531 14.477c3.103 3.104 4.031 7.771 2.352 11.825-1.677 4.052-5.633 6.696-10.022 6.697z"
          />
          <path
            id="Shape_33_"
            d="m548.665 142.002c37.485-43.692 51.094-110.109 54.49-130.392.541-3.174-.495-6.412-2.778-8.682-2.26-2.299-5.509-3.334-8.682-2.767-20.294 3.397-86.711 17.017-130.381 54.49z"
          />
          <path
            id="Shape_32_"
            d="m209.884 600.095 59.374-59.862c2.021-2.037 3.152-4.792 3.147-7.662l-.098-82.902-114.113 114.124 36.312 36.301c2.036 2.044 4.803 3.194 7.689 3.194s5.653-1.149 7.689-3.193z"
          />
          <path
            id="Shape_31_"
            d="m39.197 444.785.271.282 29.302-29.247 73.797-73.797 11.004-11.07h-83.119c-2.883.001-5.648 1.149-7.684 3.191l-59.601 59.754c-2.039 2.046-3.179 4.82-3.167 7.708.012 2.888 1.175 5.653 3.232 7.681z"
          />
        </g>
      </g>
    </g>
  </svg>
);
